import type {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  SortModelItem
} from 'ag-grid-enterprise';

export const ALERT_RULES_TABLE_DEFAULT_SORT_MODEL: SortModelItem[] = [
  {
    colId: 'last_triggered_at',
    sort: 'desc'
  }
];

export const ALERT_RULES_SEARCHABLE_SELECT_FILTERS = [
  {
    field: 'repo',
    title: 'Repo',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: [],
    hidden: false
  },
  // TODO: enable labels filter when labels are ready
  // {
  //   field: 'labels',
  //   title: 'Labels',
  //   config: {
  //     searchable: false,
  //     showCounts: true
  //   },
  //   filterOptions: [],
  //   hidden: false
  // },
  {
    field: 'enabled',
    title: 'Alerting',
    config: {
      searchable: false,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: [
      {
        id: 1,
        label: 'Enabled',
        value: 'true'
      },
      {
        id: 2,
        label: 'Disabled',
        value: 'false'
      }
    ]
  },
  {
    field: 'ai_enabled',
    title: 'AI Analysis',
    config: {
      searchable: false,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: [
      {
        id: 1,
        label: 'Enabled',
        value: 'true'
      },
      {
        id: 2,
        label: 'Disabled',
        value: 'false'
      }
    ]
  },
  {
    field: 'ai_escalation',
    title: 'AI Escalation',
    config: {
      searchable: false,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: [
      {
        id: 1,
        label: 'Enabled',
        value: 'true'
      },
      {
        id: 2,
        label: 'Disabled',
        value: 'false'
      }
    ]
  },
  {
    field: 'tuning',
    title: 'Tuning',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  }
];

export const ALERT_RULE_MAIN_DETAILS = {
  name: 'Name',
  repo: 'Repo',
  last_triggered_at: 'Last Triggered',
  updated_at: 'Updated At',
  enabled: 'Alerting Enabled (Logscale)',
  ai_enabled: 'AI Analysis Enabled',
  ai_escalation: 'AI Escalation (Ticketing) Enabled'
};

export const ALERT_RULE_METRICS = [
  'soc_escalated_true_positives',
  'ai_escalated_true_positives',
  'scope_escalated_true_positives',
  'soc_escalated_false_positives',
  'ai_escalated_false_positives',
  'soc_false_positives',
  'ai_false_positives'
];

export const ALERT_RULE_METRICS_KEY_VALUES = {
  case_count: 'Cases',
  case_count_benign: 'Benign Cases',
  case_count_fp: 'False Positive Cases',
  case_count_tp: 'True Positive Cases',
  benign_from_scope_tickets: 'Scope Benign Cases',
  benign_from_swimlane_only: 'SL Benign Cases',
  fp_from_scope_tickets: 'Scope False Positive Cases',
  fp_from_swimlane_only: 'SL False Positive Cases'
};

export const ALERT_RULE_METRICS_COLUMNS: (ColDef | ColGroupDef)[] = [
  { field: 'field', headerName: 'Source', width: 100, flex: 1, minWidth: 100 },
  { field: 'total', headerName: 'Total', width: 100 },
  { field: 'tp', headerName: 'True Positive', width: 120 },
  { field: 'fp', headerName: 'False Positive', width: 130 },
  {
    field: 'benign',
    headerName: 'Benign',
    width: 100,
    cellRenderer: (params: ICellRendererParams) => params.value ?? '--'
  }
];

export const ALERT_RULES_TUNING_OPTIONS = ['organization', 'global'];

export default ALERT_RULES_SEARCHABLE_SELECT_FILTERS;
